import { useEffect, useRef, useState } from "react";
import { InputBase } from "@mui/material";
import { colors } from "../constants/designTokens";
import {
  formatWholeNumberInput,
  roundWholeNumber,
  sanitizeWholeNumberInput,
} from "../utils/numericInputs";

export default function CurrencyField({
  value,
  onChange,
  disabled = false,
  ariaLabel = "Valor monetario sem casas decimais",
}) {
  const [displayValue, setDisplayValue] = useState(formatWholeNumberInput(value));
  const isEditingRef = useRef(false);

  useEffect(() => {
    if (!isEditingRef.current) {
      setDisplayValue(formatWholeNumberInput(value));
    }
  }, [value]);

  function handleChange(event) {
    const digits = sanitizeWholeNumberInput(event.target.value);
    const nextValue = digits ? roundWholeNumber(digits) : 0;
    setDisplayValue(digits ? formatWholeNumberInput(nextValue) : "");
    onChange(nextValue);
  }

  function handleBlur() {
    isEditingRef.current = false;
    setDisplayValue(formatWholeNumberInput(value));
  }

  function handleFocus(event) {
    isEditingRef.current = true;
    setDisplayValue(formatWholeNumberInput(value));

    const input = event.currentTarget;
    requestAnimationFrame(() => input.select());
  }

  function handlePaste(event) {
    event.preventDefault();
    const nextValue = roundWholeNumber(event.clipboardData.getData("text"));
    setDisplayValue(formatWholeNumberInput(nextValue));
    onChange(nextValue);
  }

  return (
    <InputBase
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onPaste={handlePaste}
      disabled={disabled}
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        "aria-label": ariaLabel,
      }}
      startAdornment={<span style={{ marginRight: 8, color: "var(--ac-soft-muted, #8fa0bb)" }}>R$</span>}
      sx={{
        width: "100%",
        px: 1.2,
        py: 0.55,
        borderRadius: 1.4,
        border: "1px solid #ffd964",
        bgcolor: "var(--ac-editable-bg, #fffdf0)",
        color: colors.text,
        fontSize: 12,
        "& input": {
          textAlign: "right",
          fontSize: 12,
          fontWeight: 700,
        },
      }}
    />
  );
}
